export default __webpack_public_path__ + "static/media/ecomerce.de2ef683.PNG";